<template>
  <form @submit.prevent="getList()" method="GET" novalidate>
    <div class="card-body">
      <div class="form-row">
        <div class="col-md-6">
          <div class="form-group from-row">
            <label class="col-md-3 col-form-label" for="lesson_title"
              >Lesson Title</label
            >
            <div class="col-md-9">
              <input
                type="text"
                id="lesson_title"
                class="form-control"
                v-model="search.lesson_title"
                placeholder="Lesson Title"
              />
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group from-row">
            <label class="col-md-3 col-form-label" for="course_id"
              >Course</label
            >
            <div class="col-md-9">
              <multiselect
                id="course_id"
                name="course_id"
                :options="Object.keys(courseOps)"
                :custom-label="(opt) => courseOps[opt]"
                v-bind:class="{ 'has-error': errors.has('course_id') }"
                v-validate="'required'"
                v-model="search.course_id"
                class="course_id"
                placeholder="Select Course"
                :searchable="true"
                :close-on-select="true"
                :show-labels="false"
              ></multiselect>
            </div>
          </div>
        </div>
      </div>
      <div class="form-row">
        <div class="col-md-6">
          <div class="form-group from-row">
            <label class="col-md-3 col-form-label" for="section_id"
              >Section</label
            >
            <div class="col-md-9">
              <multiselect
                id="section_id"
                name="section_id"
                :options="Object.keys(sectionOps)"
                :custom-label="(opt) => sectionOps[opt]"
                v-bind:class="{ 'has-error': errors.has('section_id') }"
                v-validate="'required'"
                v-model="search.section_id"
                class="section_id"
                placeholder="Select Section"
                :searchable="true"
                :close-on-select="true"
                :show-labels="false"
              ></multiselect>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <div class="row">
            <div class="col-md-9">
              <button type="submit" class="btn btn-common m-2px">
                <i class="fas fa-search"></i> Search
              </button>
              <button
                type="reset"
                class="btn btn-warning"
                @click="resetFilter()"
              >
                <i class="fas fa-undo"></i> Reset
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>
<script>
export default {
  props: ["filter", "courseOps", "sectionOps"],
  data: () => ({
    search: {},
  }),
  mounted() {
    this.search = this.filter;
  },
  methods: {
    resetFilter() {
      this.$router.push({ path: this.$route.path }).catch(() => {});
    },
    getList() {
      this.$router.push({
        path: this.$route.fullPath,
        query: this.search,
      });
    },
  },
};
</script>
